import { Component, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { interval } from 'rxjs';
import { filter, takeUntil, withLatestFrom } from 'rxjs/operators';
import { getIsLoggedIn } from 'src/app/authentication/state/authentication.selector';
import { Register } from 'src/app/common-components/register/models/register';
import {
   BannedProvisioningIpOrderingOptions,
   BannedProvisioningIpRegisterOptions,
} from '../models/banned-provisioning-ip-register-options';
import { BannedProvisioningIpRegisterListItem } from '../models/banned-provisioning-ip-register-results.model';
import {
   allowIp,
   bannedProvisioningIpRegisterAdapterActions,
   refreshList,
   unbanIp,
} from '../state/banned-provisioning-ip-register.actions';
import * as bannedProvisioningIpRegisterReducer from '../state/banned-provisioning-ip-register.reducer';

@Component({
   encapsulation: ViewEncapsulation.None,
   selector: 'ndt-banned-provisioning-ip-register',
   styleUrls: [],
   templateUrl: './banned-provisioning-ip-register.component.html',
   standalone: false,
})
export class BannedProvisioningIpRegisterComponent extends Register<
   BannedProvisioningIpRegisterListItem,
   BannedProvisioningIpRegisterOptions,
   BannedProvisioningIpOrderingOptions
> {
   entityName = 'Banned IP';

   columns: string[] = ['type', 'ipAddress', 'firstSeen', 'updateDate', 'status', 'bannedIpActionsMenu'];

   constructor(public store: Store) {
      super(store, bannedProvisioningIpRegisterReducer.selectors, bannedProvisioningIpRegisterAdapterActions);

      this.set30SecondRefresh();
   }

   onAllowIp(event: BannedProvisioningIpRegisterListItem) {
      if (event.ipAddress == null) {
         return;
      }

      this.store.dispatch(allowIp({ blockedIpType: event.type, ipAddress: event.ipAddress }));
   }

   onUnbanIp(event: BannedProvisioningIpRegisterListItem) {
      if (event.blockedIpAddressId == null) {
         return;
      }

      this.store.dispatch(
         unbanIp({
            blockedIpAddressId: event.blockedIpAddressId,
            ipAddress: event.ipAddress ?? '',
         })
      );
   }

   private set30SecondRefresh() {
      interval(30 * 1000)
         .pipe(
            withLatestFrom(this.store.select(getIsLoggedIn)),
            filter(([, isLoggedIn]) => isLoggedIn),
            takeUntil(this.destroyed$)
         )
         .subscribe(() => {
            this.store.dispatch(refreshList());
         });
   }
}
